import { Component } from '@angular/core';

// Imports Standalone
import { PageHeaderComponent } from '../page-header/page-header.component';
import { RegisterFormComponent } from './pages/register-form/register-form.component';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.less'],
    imports: [
        PageHeaderComponent,
        RegisterFormComponent
    ]
})
export class RegisterComponent {

}
